import React, { useContext } from "react";
import { Navigate } from "react-router-dom";
import { useSequence } from "../components/SequenceProvider";
import { AuthContext } from "../contexts/AuthContext";
import { jwtDecode } from "jwt-decode";
const ProtectedRoute = ({ children }) => {
  const { isSequenceStarted, isSequenceCompleted } = useSequence();
  const { jwtToken } = useContext(AuthContext);
  const decodedToken = jwtDecode(jwtToken);
  console.log(decodedToken);
  if (!isSequenceStarted || isSequenceCompleted) {
    // Redirect to the home/dashboard page if the sequence is not started or completed
    return <Navigate to={`/${decodedToken.user_id}/manager/assessments`} />;
  }

  return children;
};

export default ProtectedRoute;
